import Vue from "vue";

// register plugins hooks fo vue component
import "common/registerHooks";

import * as svgicon from "vue-svgicon";
// import all icons
import "components/icons";

import router from "router";
import store from "store";

import App from "pages/App";

import "mint-ui/lib/style.css";
import { Swipe, SwipeItem } from "mint-ui";
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

import VueViewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(VueViewer);

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

Vue.use(svgicon, {
  tagName: "icon"
});

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/main.ts